import * as React from 'react';

export const CloudDownloadIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="cloud-download">
      <path
        id="Vector"
        opacity="0.4"
        d="M13.792 4.57141C12.649 3.56341 11.146 2.95044 9.5 2.95044C5.91 2.95044 3 5.86044 3 9.45044C3 13.0404 5.91 15.9504 9.5 15.9504H16C18.76 15.9504 21 13.7104 21 10.9504C21 8.19044 18.76 5.95044 16 5.95044C15.67 5.95044 15.35 5.98041 15.03 6.04041C14.692 5.49141 14.274 4.99641 13.792 4.57141Z"
        fill="black"
      />
      <path
        id="Vector_2"
        d="M14.5301 18.4705C14.2371 18.1775 13.762 18.1775 13.469 18.4705L12.749 19.1905V11.0005C12.749 10.5865 12.413 10.2505 11.999 10.2505C11.585 10.2505 11.249 10.5865 11.249 11.0005V19.1895L10.5291 18.4695C10.2361 18.1765 9.76104 18.1765 9.46804 18.4695C9.17504 18.7625 9.17504 19.2375 9.46804 19.5305L11.468 21.5305C11.537 21.5995 11.6199 21.6545 11.7119 21.6925C11.8039 21.7305 11.901 21.7505 11.999 21.7505C12.097 21.7505 12.1939 21.7305 12.2859 21.6925C12.3779 21.6545 12.4611 21.5995 12.5301 21.5305L14.5301 19.5305C14.8231 19.2385 14.8231 18.7625 14.5301 18.4705Z"
        fill="black"
      />
    </g>
  </svg>
);
